// src/hooks/useCustomerPortal.js
import { useState, useEffect } from 'react';
import { doc, onSnapshot, collection, query, where, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

// Hook for customer to get their own customer record
export function useCustomerData(customerId) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!customerId) {
      setCustomer(null);
      setLoading(false);
      return;
    }

    const unsubscribe = onSnapshot(
      doc(db, 'customers', customerId),
      (doc) => {
        if (doc.exists()) {
          setCustomer({ id: doc.id, ...doc.data() });
        } else {
          setCustomer(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching customer:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [customerId]);

  return { customer, loading, error };
}

// Hook for customer to get their orders
export function useCustomerOrders(customerId) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!customerId) {
      setOrders([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'orders'),
      where('customerId', '==', customerId),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q,
      (snapshot) => {
        const orderList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setOrders(orderList);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching customer orders:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [customerId]);

  return { orders, loading, error };
}
